import AbstractCommand from "./AbstractCommand";
import PlatformAPIService from "../../equalture/platform/PlatformAPIService";

export default class ExitGameCommand extends AbstractCommand {
    /**    
     * @param {PlatformAPIService} platformAPIService 
     */
    constructor(platformAPIService) {
        super();

        this._platformAPIService = platformAPIService;
    }

    execute() {
        this._platformAPIService.exit();
    }
}